var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div-flex',{attrs:{"left":""}},[_c('div-width',{attrs:{"width":"0.5vw"}},[_c('div-height',{attrs:{"height":"4vw","bg":"#E72626"}})],1),_c('div-width',{attrs:{"width":"2vw"}}),_c('div-text',{attrs:{"color":"#333","size":"4vw","bold":""}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }